module.exports = __webpack_public_path__ + "static/media/Q1.d8631d61.jpg";